export const REG_EX_USERNAME = /^[a-zA-Zá-žÁ-Ž][\wá-žÁ-Ž]{3,100}$/;

export const REG_EX_EMAIL = /^[\w-+]+(\.[\w-]+)*@[A-Za-z\d-]+(\.[A-Za-z\d]+)*(\.[A-Za-z]{2,})$/;

export const REG_EX_FIRST_NAME = /^[A-ZÁ-Ž][a-zA-Zá-žÁ-Ž]{1,30}$/;

export const REG_EX_LAST_NAME = /^[A-ZÁ-Ž][a-zA-Zá-žÁ-Ž]{3,50}$/;

export const REG_EX_PASSWORD = /^(?=.*[\d])(?=.*[a-z])(?=.*[A-Z])(?=.*[á-žÁ-Ž])(?=.*[!"#$%&'()*+,\-.\\/:;<=>?@[\]^_`{|}~¡¢£¤¥¦§¨©ª«¬®¯°±²³´µ¶·¸¹º»¼½¾¿×÷–―‗‘’‚‛“”„†‡•…‰′″‹›‼‾⁄⁊₠₡₢₣₤₥₦₧₨₩₪₫€₭₮₯₰₱₲₳₴₵₶₷₸₹₺₻₼₽₾])(?=\S+$).{8,50}/
